import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { removeLoginSession } from '../../utils/common';
import { useSelector } from 'react-redux';

const SessionError = () => {
    const navigate = useNavigate();
    const bankLogo = useSelector((state: any) => state.layout.bankLogo);
    window.history.forward();

    useEffect(() => {
        removeLoginSession();
    }, [])

    return (
        <div>
            <Container style={{ height: '100vh', padding: '0 10px 10px 10px' }} className='d-flex justify-content-center align-items-center'>
                <Row>
                    <Col md={6} className='d-none d-md-block'>
                        <div>
                            <img src="/imgaes/session.png" alt="" className='w-100' />
                        </div>
                    </Col>

                    <Col md={6} className='d-flex justify-content-center align-items-center flex-col pb-3'>
                        <div>
                            <div className="company-logo d-flex justify-content-center my-3">
                                <img
                                    src={bankLogo.loginLogo}
                                    alt="company-logo"
                                    style={{ width: bankLogo.loginLogoWidth, height: bankLogo.loginLogoHeight }}
                                />
                            </div>
                            <h1 className='text-center h-1'>Session Out</h1>
                            <div className='mt-3'>
                                <p className='text-center text-slate-500'>We're sorry, your session time is over.</p>
                                <p className='text-center text-slate-500'>Please go back to the home page.</p>
                            </div>
                            <div className='d-flex justify-content-center mt-3'>
                                <Button
                                    variant="orange"
                                    type="submit"
                                    className="btn btn-orange"
                                    style={{
                                        width: 150,
                                    }}
                                    onClick={() => navigate('/')}
                                >
                                    Go Home
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default SessionError
